__turbopack_context__.v({
  "become-producer": "BecomeProducer-module-scss-module__3_A-1a__become-producer",
  "become-producer-left": "BecomeProducer-module-scss-module__3_A-1a__become-producer-left",
  "become-producer-right": "BecomeProducer-module-scss-module__3_A-1a__become-producer-right",
  "img": "BecomeProducer-module-scss-module__3_A-1a__img",
});
